const deviceStatus = {
    available: 'Available',
    inactive: 'Inactive',
    blocked: 'blocked',
}

export default deviceStatus